import { BaseSearchInput, SearchInputItem } from '@shared/components/inputs/BaseSearchInput'
import { FilterOperators, useFilterTrainingCompaniesQuery } from '@typings/graphql'
import React from 'react'
import { RegisterOptions } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const MIN_VALUE_LENGTH = 3

type Props = {
  description?: string
  options?: RegisterOptions
  additionalFilters?: {
    field: string
    value: string | string[]
    operator: FilterOperators
  }[]
}

export const TrainingCompanySearch:React.FC<Props> = ({ description, options, additionalFilters }) => {
  const [queriedTrainingCompanies, setQueriedTrainingCompanies] = React.useState<SearchInputItem[]>([])
  const [loading, setLoading] = React.useState(false)

  const { t } = useTranslation()

  const { fetchMore } = useFilterTrainingCompaniesQuery({
    skip: true
  })

  const handleInputChange = React.useCallback(async (value: string) => {
    setLoading(true)

    if (!value || value.length < MIN_VALUE_LENGTH) {
      setQueriedTrainingCompanies([])
      setLoading(false)

      return
    }

    const { data } = await fetchMore({
      variables: {
        filter: [{
          field: 'name',
          value: value.toLowerCase(),
          operator: FilterOperators.Contains
        }, ...(additionalFilters || [])]
      }
    })

    const trainingCompanies = data?.filterTrainingCompanies?.map((trainingCompany) => ({
      id: trainingCompany.id,
      name: trainingCompany.name
    }))

    setQueriedTrainingCompanies(trainingCompanies || [])

    setLoading(false)
  }, [])

  return (
    <BaseSearchInput
      formKey="trainingCompanies"
      title={t('common.trainingCompany')}
      description={description}
      options={options}
      single
      onInputChange={handleInputChange}
      loading={loading}
      minLength={MIN_VALUE_LENGTH}
      searchItems={queriedTrainingCompanies}
    />
  )
}
